const clockFormat = new Intl.DateTimeFormat("sv-SE", { hour: "2-digit", minute: "2-digit" })

export function formatClock(date: Date): string {
  return clockFormat.format(date)
}

export function formatClockRange(start: Date, end: Date | null): string {
  return end === null ? `${formatClock(start)} →` : `${formatClock(start)} → ${formatClock(end)}`
}

export function formatDuration(minutes: number): string {
  const abs = Math.max(0, minutes)
  const h = Math.floor(abs / 60)
  const m = abs % 60
  return h > 0 ? `${h} h ${m} min` : `${m} min`
}

// Below this, an ongoing sleep counts as "just fell asleep" — the elapsed
// duration isn't meaningful yet.
export const JUST_FELL_ASLEEP_MIN = 5

export function sleepElapsedLabel(minutes: number): string {
  return minutes < JUST_FELL_ASLEEP_MIN
    ? "Har precis somnat"
    : `Har sovit i ${formatDuration(minutes)}`
}

// Whole minutes between two epoch-ms instants, floored and clamped to 0.
export function minutesBetween(later: number, earlier: number): number {
  return Math.max(0, Math.floor((later - earlier) / 60_000))
}

const pad = (n: number) => String(n).padStart(2, "0")

// Local "YYYY-MM-DD" — never new Date(str).toISOString(), which shifts by the UTC offset.
export function formatLocalIsoDate(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

// Parse "YYYY-MM-DD" as a local date; undefined on a missing/malformed part.
export function parseLocalIsoDate(value: string): Date | undefined {
  const [y, m, d] = value.split("-").map(Number)
  return y && m && d ? new Date(y, m - 1, d) : undefined
}

// Local "YYYY-MM-DDTHH:mm" for a datetime-local input.
export function toDatetimeLocalValue(date: Date): string {
  return `${formatLocalIsoDate(date)}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}
